import * as React from "react";
import { cn } from "@repo/utils/cn";
import { tv, VariantProps } from "tailwind-variants";
import { Breadcrumbs, BreadcrumbItem } from "../Breadcrumbs";
import { sectionWrapper } from "../sectionWrappers";

const breadcrumbsSection = tv({
  base: "uipm:w-full uipm:px-[var(--container-margin)] uipm:lg:pl-0 uipm:py-[var(--container-card-medium-padding,56px)] uipm:flex uipm:items-center",
});

const breadcrumbsLayout = tv({
  base: cn(
    "uipm:w-full uipm:max-w-[1200px] uipm:mx-auto uipm:lg:max-w-[920px]",
  ),
});

export interface BreadcrumbsSectionProps
  extends VariantProps<typeof sectionWrapper> {
  items: BreadcrumbItem[];
  id?: string;
  className?: string;
  [key: string]: any;
}

export const BreadcrumbsSection = React.forwardRef<
  HTMLElement,
  BreadcrumbsSectionProps
>(
  (
    {
      items,
      backgroundColor = "none",
      topPadding = "none",
      bottomPadding = "none",
      className,
      id,
      pageType = "location",
      ...props
    },
    ref,
  ) => {
    if (!items || items.length === 0) {
      return null;
    }

    return (
      <section
        id={id}
        ref={ref}
        className={sectionWrapper({
          backgroundColor,
          topPadding,
          bottomPadding,
          pageType,
        })}
        {...props}
      >
        <div className={breadcrumbsSection()}>
          <div className={cn(breadcrumbsLayout(), className)}>
            <Breadcrumbs items={items} />
          </div>
        </div>
      </section>
    );
  },
);

BreadcrumbsSection.displayName = "BreadcrumbsSection";
